import '../css/content.css';
import StoreItems from './StoreItems';
import Training from './Training';



function Content() {
  return (<>
    <Training />
    <div className='content'>
      <StoreItems />
    </div>
  </>);
}

export default Content;
